{
  "name": "personal-area",
  "version": "10.84.1",
  "license": "MIT",
  "scripts": {
    "ng": "nx",
    "start:finex": "nx run finex:serve",
    "start:finex:test": "nx run finex:serve:test",
    "start:finex:prod": "nx run finex:serve:production",
    "start:finex:server": "node dist/finex/server/server.mjs",
    "start:finex-billing": "nx run finex-billing:serve:local",
    "start:finex-ib": "nx run finex-ib:serve:local",
    "start:partner": "nx run partner:serve:local",
    "build:finex-verification": "nx run finex-verification:build",
    "build:finex-verification:test": "nx run finex-verification:build:test",
    "build:finex-billing": "nx run finex-billing:build",
    "build:finex-billing:test": "nx run finex-billing:build:test",
    "build:finex-ib": "nx run finex-ib:build",
    "build:finex-ib:test": "nx run finex-ib:build:test",
    "build:finex": "nx run finex:build",
    "build:finex-docs": "nx run finex-docs:build",
    "build:partner": "nx run partner:build:test",
    "build:partner:production": "nx run partner:build:production",
    "e2e:finex": "DEBUG=pw:api npx playwright test --headed --config=apps/finex-e2e/src/playwright.config.local.ts",
    "start:global": "nx run global:serve",
    "build:global": "nx run global:build",
    "build:global:test": "nx run global:build:test",
    "test:global": "nx test global",
    "test:global:coverage": "nx test global --code-coverage",
    "test:global:coverage:ci": "nx test global --code-coverage --no-watch --progress=false --browsers=ChromeHeadlessNoSandbox",
    "test:global:ci": "nx test global --no-watch --progress=false --browsers=ChromeHeadlessNoSandbox",
    "test:global:unit": "nx test global --browsers=ChromeHeadlessNoSandbox",
    "test:e2e:partner": "DEBUG=pw:api npx playwright test --headed --config=apps/partner-e2e/src/playwright.config.local.ts",
    "test:e2e:partner:ci": "npx playwright test --config=apps/partner-e2e/src/playwright.config.test.ts",
    "test:e2e:finances": "DEBUG=pw:api npx playwright test --config=apps/finances-e2e/src/playwright.config.local.ts",
    "test:e2e:finances:ci": "npx playwright test --config=apps/finances-e2e/src/playwright.config.test.ts",
    "test:e2e:finex": "DEBUG=pw:api npx playwright test --config=apps/finex-e2e/src/playwright.config.local.ts",
    "test:e2e:finex:ci": "npx playwright test --config=apps/finex-e2e/src/playwright.config.test.ts",
    "test:app": "nx test app",
    "test:app:ci": "nx test app --progress=false --browsers=ChromeHeadlessNoSandbox",
    "test:finances": "nx test finances",
    "test:all": "nx run-many --target=test --projects=global,finances",
    "test:all:ci": "nx run-many --target=test --projects=global,finances --progress=false --browsers=ChromeHeadlessNoSandbox",
    "partner:serve-ssr": "nx run partner:build:test && rm -rf partner && mkdir partner &&  mv dist/partner/browser partner/dist && mv dist/partner/server partner/dist-server && cd partner && node ./dist-server/server.mjs",
    "cz": "cz",
    "release": "standard-version",
    "svg:optimize:finex": "svgo -f ./apps/finex/src/assets/img/sprite/src",
    "svg:optimize:global": "svgo -f ./libs/global/ui/src/assets/img/sprite/src",
    "svg:sprite-generate:finex": "npm run svg:optimize:finex && svg2sprite ./apps/finex/src/assets/img/sprite/src ./apps/finex/src/assets/img/sprite/dist/sprite.svg",
    "svg:sprite-generate:global": "npm run svg:optimize:global && svg2sprite ./libs/global/ui/src/assets/img/sprite/src ./libs/global/ui/src/assets/img/icons/sprite.svg",
    "lint:scss": "stylelint scss \"**/*.scss\"",
    "lint:scss:fix": "stylelint scss \"**/*.scss\" --fix",
    "lint-staged": "stylelint scss \"**/*.scss\" --fix",
    "prepare": "husky install"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "18.2.9",
    "@angular/cdk": "18.2.9",
    "@angular/common": "18.2.9",
    "@angular/compiler": "18.2.9",
    "@angular/core": "18.2.9",
    "@angular/fire": "^18.0.1",
    "@angular/forms": "18.2.9",
    "@angular/material": "18.2.9",
    "@angular/material-moment-adapter": "18.2.9",
    "@angular/platform-browser": "18.2.9",
    "@angular/platform-browser-dynamic": "18.2.9",
    "@angular/platform-server": "18.2.9",
    "@angular/pwa": "18.2.9",
    "@angular/router": "18.2.9",
    "@angular/service-worker": "18.2.9",
    "@angular/ssr": "18.2.9",
    "@grpc/grpc-js": "^1.12.5",
    "@grpc/proto-loader": "^0.7.13",
    "@maskito/angular": "^3.2.1",
    "@maskito/core": "^3.2.1",
    "@maskito/kit": "^3.2.1",
    "@nestjs/common": "10.4.13",
    "@nestjs/core": "10.4.13",
    "@nestjs/microservices": "10.4.13",
    "@nestjs/platform-express": "10.4.13",
    "@nestjs/platform-socket.io": "10.4.13",
    "@nestjs/websockets": "10.4.13",
    "@ng-doc/app": "18.3.1",
    "@ng-doc/builder": "18.3.1",
    "@ng-doc/core": "18.3.1",
    "@ng-doc/ui-kit": "18.3.1",
    "@ng-select/ng-select": "^13.9.1",
    "@ngrx/component": "18.1.1",
    "@ngrx/component-store": "18.1.1",
    "@ngrx/effects": "18.1.1",
    "@ngrx/entity": "18.1.1",
    "@ngrx/operators": "^18.0.0",
    "@ngrx/router-store": "18.1.1",
    "@ngrx/schematics": "18.1.1",
    "@ngrx/store": "18.1.1",
    "@ngrx/store-devtools": "18.1.1",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@nx/angular": "19.8.9",
    "@sentry/angular": "^8.47.0",
    "@sentry/tracing": "^7.120.2",
    "@sumsub/websdk": "^2.0.1",
    "amqp-connection-manager": "^4.1.14",
    "amqplib": "^0.10.5",
    "angularx-qrcode": "^18.0.2",
    "axios": "^1.7.9",
    "browser-image-compression": "^2.0.2",
    "cache-manager": "^3.6.1",
    "chart.js": "^3.9.1",
    "class-transformer": "^0.2.3",
    "class-validator": "^0.9.1",
    "cookie-parser": "^1.4.6",
    "crypto-js": "^4.1.1",
    "decimal.js-light": "^2.5.1",
    "express": "~4.18.2",
    "helmet": "^5.0.2",
    "ioredis": "^5.4.2",
    "jwt-decode": "^4.0.0",
    "kafkajs": "^2.2.4",
    "libphonenumber-js": "^1.10.6",
    "memory-cache": "^0.2.0",
    "moment": "^2.29.3",
    "moment-timezone": "^0.5.33",
    "mqtt": "^5.10.3",
    "nats": "^2.29.1",
    "ng2-charts": "^3.1.2",
    "ngx-captcha": "^13.0.0",
    "ngx-clipboard": "^15.1.0",
    "ngx-cookie-service": "^18.0.0",
    "ngx-cookie-service-ssr": "^18.0.0",
    "ngx-skeleton-loader": "^7.0.0",
    "normalize-diacritics": "^2.13.2",
    "pg": "^8.11.5",
    "queueing-subject": "^1.0.0",
    "reflect-metadata": "^0.1.13",
    "rxjs": "7.8.1",
    "sha256": "^0.2.0",
    "text-mask-addons": "^3.8.0",
    "ts-key-enum": "^2.0.11",
    "ts-md5": "^1.2.11",
    "tslib": "^2.3.0",
    "zone.js": "0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "18.2.9",
    "@angular-devkit/core": "18.2.9",
    "@angular-devkit/schematics": "18.2.9",
    "@angular-eslint/eslint-plugin": "18.4.3",
    "@angular-eslint/eslint-plugin-template": "18.4.3",
    "@angular-eslint/template-parser": "18.4.3",
    "@angular/compiler-cli": "18.2.9",
    "@angular/language-service": "18.2.9",
    "@commitlint/cli": "18.6.1",
    "@commitlint/config-angular": "18.6.1",
    "@commitlint/config-conventional": "18.6.1",
    "@nestjs/schematics": "10.2.3",
    "@nestjs/testing": "10.4.9",
    "@ngneat/spectator": "^19.2.0",
    "@nx/devkit": "19.8.9",
    "@nx/eslint": "19.8.9",
    "@nx/eslint-plugin": "19.8.9",
    "@nx/jest": "19.8.9",
    "@nx/js": "19.8.9",
    "@nx/nest": "19.8.9",
    "@nx/node": "19.8.9",
    "@nx/playwright": "19.8.9",
    "@nx/web": "^19.8.14",
    "@nx/workspace": "19.8.9",
    "@playwright/test": "^1.43.0",
    "@schematics/angular": "18.2.9",
    "@sentry/cli": "^2.45.0",
    "@swc-node/register": "~1.9.1",
    "@swc/core": "~1.5.7",
    "@swc/helpers": "~0.5.11",
    "@trivago/prettier-plugin-sort-imports": "^3.2.0",
    "@types/apple-signin-api": "^1.5.1",
    "@types/cache-manager": "^3.4.3",
    "@types/cookie-parser": "^1.4.2",
    "@types/crypto-js": "^4.1.1",
    "@types/express": "4.17.14",
    "@types/facebook-js-sdk": "3.3.5",
    "@types/jest": "29.5.14",
    "@types/memory-cache": "^0.2.2",
    "@types/node": "18.19.9",
    "@types/pg": "^8.11.4",
    "@types/sha256": "^0.2.0",
    "@typescript-eslint/eslint-plugin": "7.18.0",
    "@typescript-eslint/parser": "7.18.0",
    "@typescript-eslint/utils": "^7.16.0",
    "browser-sync": "^3.0.0",
    "browserslist": "^4.23.2",
    "commitizen": "^4.2.4",
    "conventional-changelog-eslint": "^3.0.9",
    "domino": "https://github.com/angular/domino.git#8f228f8862540c6ccd14f76b5a1d9bb5458618af",
    "eslint": "8.57.1",
    "eslint-config-prettier": "9.1.0",
    "eslint-plugin-playwright": "^1.6.2",
    "eslint-plugin-rxjs": "5.0.3",
    "husky": "^8.0.0",
    "jest": "29.7.0",
    "jest-environment-jsdom": "29.7.0",
    "jest-preset-angular": "14.1.1",
    "lint-staged": "^13.0.3",
    "localstorage-polyfill": "^1.0.1",
    "ng-mocks": "^14.11.0",
    "ngrx-store-freeze": "^0.2.4",
    "nx": "19.8.9",
    "prettier": "2.8.8",
    "prettier-plugin-organize-attributes": "^0.0.5",
    "puppeteer": "^12.0.1",
    "standard-version": "^9.3.2",
    "stylelint": "^14.14.1",
    "stylelint-config-prettier": "^9.0.3",
    "stylelint-config-recommended-scss": "^8.0.0",
    "stylelint-config-standard": "^29.0.0",
    "stylelint-declaration-strict-value": "^1.9.1",
    "stylelint-order": "^5.0.0",
    "stylelint-prettier": "^2.0.0",
    "stylelint-scss": "^4.3.0",
    "svg2sprite-cli": "^2.0.1",
    "svgo": "^2.8.0",
    "ts-jest": "29.1.5",
    "ts-node": "10.9.1",
    "typescript": "5.5.4"
  },
  "commitizen": {
    "path": "cz-conventional-changelog"
  }
}
